import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {getCustomerProfile} from '../api/profile.api';
// Define a type for the slice state
interface CustomerProfileResponse {
  result: boolean;
  resultCode: string;
  message: string;
  firstName: string;
  tier: string;
  pointsAvailable: number;
  pointToExpire: number;
  cardNumber: string;
  email: string;
  gender: string;
  dob: string;
  lastName: string | null;
  sbiPointBal:number;
}

const customerProfileData = {
  result: false,
  resultCode: '',
  message: '',
  firstName: '',
  tier: '',
  pointsAvailable: 0.0,
  pointToExpire: 0,
  cardNumber: '',
  email: '',
  gender: '',
  dob: '',
  lastName: null,
};

interface FetchCustomerProfilePayload {
  payload: {
    source: string;
    locationCode: string;
    mobileNumber: string | null;
    orderId?:string;
  };
  accessToken: string;
}

interface ProfileState {
  customerProfile: CustomerProfileResponse;
  loading: boolean;
  error: string;
}
// Define the initial state using that type
const initialState: ProfileState = {
  customerProfile: customerProfileData,
  loading: false,
  error: '',
};
export const fetchCustomerProfile = createAsyncThunk(
  'profile/customerSearch',
  async (parameters: FetchCustomerProfilePayload, thunkApi) => {
    return getCustomerProfile(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const customerSearchSlice = createSlice({
  name: 'customerSearch',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
    loading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchCustomerProfile.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchCustomerProfile.fulfilled, (state, {payload}) => {
      state.customerProfile = payload;
      state.loading = false;
    });
    builder.addCase(fetchCustomerProfile.rejected, (state, action) => {
      state.error = action.toString();
      state.loading = false;
    });
  },
});
export const {resetState} = customerSearchSlice.actions;
// Other code such as selectors can use the imported `RootState` type
// export const profileData = (state: RootState): Profile[] =>
//   state.profileReducer.updateProfileResponse;
export const error = (state: RootState): string =>
  state.customerSearchReducer.error;
export const loading = (state: RootState): boolean =>
  state.customerSearchReducer.loading;
export const customerProfile = (state: RootState): CustomerProfileResponse =>
  state.customerSearchReducer.customerProfile;
export default customerSearchSlice.reducer;
